import styled from "styled-components";

const SpinnerStyle = styled.div.attrs((props) => ({
  className: props.className,
}))``;

export default SpinnerStyle;
